import { lazy } from 'react';

const PersonalCardsSettingsPage = lazy(() => import('@/pages/Settings/PersonalCardsSettingsPage'));

export const personalCardsRoutes = [
  {
    path: "/personal-cards-settings",
    element: PersonalCardsSettingsPage,
    meta: {
      title: "Personal Cards Settings",
      description: "Configure personal cards logo and appearance"
    },
    requiresAuth: true
  }
];
